import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getData } from "../../../Core/Projects/action";
import { getPhotographers } from "../../../Core/Photogrphers/action";
import { getComments } from "../../../Core/PhotographerComments/action";
import { changeData, unchangeData } from "../../../Core/ChangeValues/action";
import Card from "./Card";
import Gallery from "./Gallery";
import Comments from "./Comments";
import Filters from "./Filters";
import Loader from "../../Loader";
import PhEr from "../../../Assets/Images/Components/Book/erPhotographer.png";
import FilterIcon from "../../../Assets/Images/filters.png";
import styles from "../../../Assets/Styles/Components/Book/Photograpers/index.module.css";

class Photographers extends Component {
  constructor() {
    super();
    this.state = {
      directPhotographer: [],
      imageContainer: null,
      comments: null,
      photographerSelected: null,
      idComments: null,
      gender: 0,
      nToShow: 3,
      grades: [],
      photographers: [],
      filteredPhotographers: [],
      modalFilters: false,
      sort: "prate",
      recommendedPhotographerUid: null,
      mostPopularUid: null,
      sortItems: [
        { title: "بالاترین نمره", value: "rate" },
        { title: "محبوب ترین", value: "prate" },
        { title: "ارزانترین", value: "cheapest" },
        { title: "پیشنهاد کادرو", value: "korate" },
        { title: "نزدیکترین", value: "price" },
        { title: "بالاترین سطح", value: "grade_order" },
        { title: "بیشترین رزرو", value: "finished_projects_count" },
        { title: "سریعترین زمان تحویل", value: "drate" },
      ],
    };
  }

  componentDidMount() {
    // document.querySelector(`.${styles.photographers}`).scrollIntoView({ behavior: "smooth", });
    if (!this.props.project.slug) {
      if (window.location.search && window.location.search.substr(1)) {
        this.props.getData(
          Object.fromEntries(
            new URLSearchParams(window.location.search.substring(1))
          ).slug,
          {}
        );
        this.props.getPhotographers(
          Object.fromEntries(
            new URLSearchParams(window.location.search.substring(1))
          ).slug
        );
      }
    }
    if (
      (this.props.project.slug &&
        this.props.photographers?.photographers &&
        Object.keys(this.props.photographers.photographers).length === 0) ||
      (this.props.project.slug && this.props.change)
    ) {
      this.props.getPhotographers(this.props.project.slug);
      this.props.unchangeData();
      this.props.project.data?.photographer_uid &&
        this.setState({
          photographerSelected: this.props.project.data.photographer_uid,
        });
    }
    if (
      this.props.project.slug &&
      this.props.photographers?.photographers &&
      Object.keys(this.props.photographers.photographers).length !== 0 &&
      this.props.project.data?.photographer_uid
    ) {
      this.setState({
        photographerSelected: this.props.project.data.photographer_uid,
      });
    }
  }

  componentDidUpdate(preProps) {
    if (
      (this.props.project &&
        this.props.project.data &&
        preProps.project.data.step !== this.props.project.data.step) ||
      (this.props.project &&
        !this.props.project.loading &&
        preProps.project.loading !== this.props.project.loading)
    ) {
      this.props.history.push(
        `/book/${this.props.project.data.step}?slug=${this.props.project.slug}`
      );
    }
    if (
      this?.props?.photographers?.photographers?.photographers?.length > 0 &&
      this.state.grades?.length === 0
    ) {
      this.addGrades();
    }
    if (
      !this?.props?.photographers?.photographers?.non_directed_candid &&
      this?.props?.photographers?.photographers?.photographers?.length > 0 &&
      this.state.photographers.length === 0
    ) {
      this.addPhotographers();
    }
    if (
      this?.props?.project?.data?.direct_photographer &&
      this?.props?.photographers?.photographers?.photographers?.length > 0 &&
      this.state.directPhotographer.length === 0
    ) {
      this.addNonDirectPhotographers();
    }
    if (
      !this.props.project.loading &&
      !this.state.photographerSelected &&
      this.props.project?.data?.photographer_uid?.length > 0
    ) {
      this.selectPhotographer();
    }
    const prevPhotographers = preProps.photographers?.photographers;
    const currentPhotographers = this.props.photographers?.photographers;

    const photographersLoadedNow =
      !prevPhotographers ||
      Object.keys(prevPhotographers).length === 0 &&
      currentPhotographers &&
      Object.keys(currentPhotographers).length > 0;

    // Do not auto-open filters on initial load

    if (photographersLoadedNow) {
      this.autoSelectRecommended();
    }
  }

  autoSelectRecommended = () => {
    const projectData = this.props.project?.data;
    if (!projectData || this.props.project.loading) return;
    if (projectData.direct_photographer) return;
    if (this.state.photographerSelected) return;

    const list = this?.props?.photographers?.photographers?.photographers || [];
    if (list.length === 0) return;

    const selected = this.getHighestFinishedProjects(list);
    if (!selected?.photographer_uid) return;

    this.setState({
      photographerSelected: selected.photographer_uid,
      recommendedPhotographerUid: selected.photographer_uid,
    });
  };

  selectPhotographer = () => {
    this.setState({
      photographerSelected: this.props.project?.data?.photographer_uid,
    });
  };

  sortByPopular = (list) => {
    return [...list].sort((a, b) =>
      (a.prate || 0) < (b.prate || 0) ? 1 : (a.prate || 0) > (b.prate || 0) ? -1 : 0
    );
  };

  gradeKeyFor = (item) => {
    if (item && item.grade !== undefined && item.grade !== null) {
      return `grade_${item.grade}`;
    }
    if (item && item.grade_order !== undefined && item.grade_order !== null) {
      return `grade_order_${item.grade_order}`;
    }
    return `uid_${item?.photographer_uid}`;
  };

  pinSelectedToTop = (list, selectedUid) => {
    if (!selectedUid) return list;
    const selected = list.find((i) => i.photographer_uid === selectedUid);
    if (!selected) return list;
    return [selected, ...list.filter((i) => i.photographer_uid !== selectedUid)];
  };

  ensureDistinctTopN = (list, n) => {
    const result = this.pinSelectedToTop([...list], this.state.photographerSelected);
    const seen = new Set();
    const limit = Math.min(n, result.length);
    for (let i = 0; i < limit; i++) {
      let key = this.gradeKeyFor(result[i]);
      if (seen.has(key)) {
        const swapIndex = result.findIndex(
          (item, idx) => idx > i && !seen.has(this.gradeKeyFor(item))
        );
        if (swapIndex !== -1) {
          const tmp = result[i];
          result[i] = result[swapIndex];
          result[swapIndex] = tmp;
          key = this.gradeKeyFor(result[i]);
        }
      }
      seen.add(key);
    }
    return result;
  };

  getHighestFinishedProjects = (list) => {
    return [...list].sort((a, b) =>
      (a.finished_projects_count || 0) < (b.finished_projects_count || 0)
        ? 1
        : (a.finished_projects_count || 0) > (b.finished_projects_count || 0)
        ? -1
        : 0
    )[0];
  };

  orderInitialByDistinctGrades = (list, preferUid) => {
    const sorted = this.sortByPopular(list);
    const selectedSet = new Set();
    const gradeSet = new Set();
    const picked = [];

    if (preferUid) {
      const preferred = sorted.find((i) => i.photographer_uid === preferUid);
      if (preferred) {
        picked.push(preferred);
        selectedSet.add(preferred.photographer_uid);
        gradeSet.add(this.gradeKeyFor(preferred));
      }
    }

    // Prefer distinct grades for top 3
    for (const item of sorted) {
      if (picked.length >= 3) break;
      if (!selectedSet.has(item.photographer_uid)) {
        const gradeKey = this.gradeKeyFor(item);
        if (!gradeSet.has(gradeKey)) {
          picked.push(item);
          selectedSet.add(item.photographer_uid);
          gradeSet.add(gradeKey);
        }
      }
    }

    // Fill remaining slots if fewer than 3 distinct grades exist
    for (const item of sorted) {
      if (picked.length >= 3) break;
      if (!selectedSet.has(item.photographer_uid)) {
        picked.push(item);
        selectedSet.add(item.photographer_uid);
      }
    }

    const remaining = sorted.filter(
      (item) => !selectedSet.has(item.photographer_uid)
    );
    return this.pinSelectedToTop([...picked, ...remaining], preferUid);
  };

  addPhotographers = () => {
    const data = this?.props?.photographers?.photographers?.photographers;
    const mostPopular = this.sortByPopular(data || [])[0];
    const highest = this.getHighestFinishedProjects(data || []);
    const ordered = this.orderInitialByDistinctGrades(
      data || [],
      highest?.photographer_uid
    );
    this.setState({
      photographers: data,
      filteredPhotographers: ordered,
      photographerSelected: this.state.photographerSelected || highest?.photographer_uid || null,
      recommendedPhotographerUid: highest?.photographer_uid || null,
      mostPopularUid: mostPopular?.photographer_uid || null,
    });
  };

  addNonDirectPhotographers = () => {
    const data = this?.props?.photographers?.photographers?.non_directed_candid;
    const mostPopular = this.sortByPopular(data || [])[0];
    const highest = this.getHighestFinishedProjects(data || []);
    const ordered = this.orderInitialByDistinctGrades(
      data || [],
      highest?.photographer_uid
    );
    this.setState({
      photographers: data,
      filteredPhotographers: ordered,
      directPhotographer:
        this?.props?.photographers?.photographers?.photographers,
      photographerSelected: this.state.photographerSelected || highest?.photographer_uid || null,
      recommendedPhotographerUid: highest?.photographer_uid || null,
      mostPopularUid: mostPopular?.photographer_uid || null,
    });
  };

  // addGrades = () => {
  //   const data = this?.props?.photographers?.photographers?.photographers?.map(
  //     (i) => i.grade
  //   );
  //   this.setState({ grades: Array.from(new Set(data)) });
  // };
  addGrades = () => {
    const directPhotographers =
      this?.props?.photographers?.photographers?.photographers || [];

    const directGrades = directPhotographers.map((i) => i.grade);

    let allGrades = [...directGrades];

    // If direct_photographer is true, include grades from non_directed_candid as well
    if (this?.props?.project?.data?.direct_photographer) {
      const candidPhotographers =
        this?.props?.photographers?.photographers?.non_directed_candid || [];
      const candidGrades = candidPhotographers.map((i) => i.grade);
      allGrades = [...allGrades, ...candidGrades];
    }

    this.setState({ grades: Array.from(new Set(allGrades)) });
  };

  emptyGallery = () => {
    this.setState({ imageContainer: null });
  };

  fillGallery = (images) => {
    this.setState({ imageContainer: images });
  };

  emptyComments = () => {
    this.setState({ comments: null, name: null, idComments: null });
    this.props.getComments(null);
  };

  fillComments = (id) => {
    this.props.getComments(id);
    this.setState({ idComments: id });
  };
  chnageGender = (number) => () => {
    this.setState({ gender: number });
    const data = [...this.state.photographers].filter((i) =>
      number ? (number === 1 ? i.gender === 1 : i.gender === 2) : i
    );
    this.setState({ filteredPhotographers: [...data] });
  };

  filterPhotographers = (gen, grades) => {
    this.setState({ modalFilters: false });
    const data = [...this.state.photographers]
      .filter((i) => {
        if (gen !== 0 && i.gender === gen) {
          return i;
        }
        if (gen === 0) {
          return i;
        }
        return null;
      })
      .filter((i) => grades.includes(i.grade) && i);
    this.setState({
      filteredPhotographers: this.pinSelectedToTop(
        [...data],
        this.state.photographerSelected
      ),
    });
  };

  changeSort = (arr, e) => {
    this.setState({ sort: e });
    switch (e) {
      case "rate":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.rate < b.rate ? 1 : a.rate > b.rate ? -1 : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "prate":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.prate < b.prate ? 1 : a.prate > b.prate ? -1 : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "cheapest":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.package_price + a.price > b.package_price + b.price
                ? 1
                : a.package_price + a.price < b.package_price + b.price
                ? -1
                : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "korate":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.korate < b.korate ? 1 : a.korate > b.korate ? -1 : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "drate":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.drate > b.drate ? 1 : a.drate < b.drate ? -1 : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "price":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.price > b.price
                ? 1
                : a.price < b.price
                ? -1
                : a.rate < b.rate
                ? 1
                : a.rate > b.rate
                ? -1
                : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "grade_order":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.grade_order < b.grade_order
                ? 1
                : a.grade_order > b.grade_order
                ? -1
                : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      case "finished_projects_count":
        this.setState({
          filteredPhotographers: this.pinSelectedToTop([
            ...arr.sort((a, b) =>
              a.finished_projects_count < b.finished_projects_count
                ? 1
                : a.finished_projects_count > b.finished_projects_count
                ? -1
                : 0
            ),
          ], this.state.photographerSelected),
        });
        break;
      default:
        break;
    }
  };

  render() {
    const { isNear, isStudio } = this.props.photographers.photographers;
    const data = this?.props?.photographers?.photographers;
    const displayPhotographers = this.ensureDistinctTopN(
      this.state.filteredPhotographers,
      3
    );
    const responsive = {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    };
    return (
      <div className={`${styles.photographers} container`}>
        <div className="row">
          <Gallery
            images={this.state.imageContainer}
            onClick={this.emptyGallery}
          />
          <Comments
            comments={this.state.comments}
            onClick={this.emptyComments}
            photographerName={this.state.name}
          />
          <Filters
            show={this.state.modalFilters}
            gender={this.state.gender}
            onClose={(_) => this.setState({ modalFilters: false })}
            grades={this.state.grades}
            onChangeFilters={this.filterPhotographers}
            sort={this.state.sort}
            sortItems={this.state.sortItems}
            onChangeSort={(value) =>
              this.changeSort(this.state.filteredPhotographers, value)
            }
          />

          <div className="col-12">
            {this.props.photographers.loading && (
              <div
                style={{ width: "100%", margin: "0 auto", padding: "10em 0" }}
              >
                <Loader scale={1} />
              </div>
            )}
            {data?.error && (
              <div className="custom-box">
                {this.props?.photographers?.photographers?.error && (
                  <>
                    <div className={styles.errorImg}>
                      <img src={PhEr} alt="PhEr" />
                    </div>
                    <p className={styles.error}>{data.error}</p>
                    <p className={styles.errorLink}>
                      <a
                        className={styles.errorButton}
                        href="https://www.kadro.co/contact_us"
                        target="_new"
                      >
                        تماس با ما
                      </a>
                    </p>
                  </>
                )}
              </div>
            )}
            {this.state.directPhotographer.length !== 0 && (
              <div className="col-12">
                <div className="custom-box">
                  {this.state.directPhotographer.map((card) => {
                    const isSelected =
                      card.photographer_uid === this.state.photographerSelected;
                    const isMostPopular =
                      card.photographer_uid === this.state.mostPopularUid;
                    return (
                      <div
                        key={card.photographer_uid}
                        className={[
                          isSelected ? styles.preselectedCard : "",
                          isMostPopular ? styles.popularCard : "",
                          !isSelected && !isMostPopular ? styles.normalCard : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      >
                        {isMostPopular && (
                          <div className={styles.popularBadgeWrap}>
                            <span role="img" aria-label="پر انتخاب‌ترین">🔥</span>{" "}
                            پر انتخاب‌ترین این هفته
                          </div>
                        )}
                        <Card
                          data={card}
                          onClick={this.fillGallery}
                          onComments={this.fillComments}
                          isStudio={isStudio}
                          idComments={this.state.idComments}
                          photographerSelected={this.state.photographerSelected}
                          isRecommended={
                            card.photographer_uid ===
                            this.state.recommendedPhotographerUid
                          }
                          isMostPopular={isMostPopular}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {this.state.directPhotographer.length !== 0 &&
              this.state.filteredPhotographers.length !== 0 && (
                <div className="col-12">
                  <h3 className={styles.others}>
                    متخصصین مناسب دیگر
                  </h3>
                </div>
              )}
            {this.state.filteredPhotographers.length !== 0 && (
              <div className="custom-box">
                <div
                  className="container"
                  style={{ padding: 0, marginBottom: "1.5em" }}
                >
                  <div className="row align-items-center">
                    <div className="col-5 col-sm-3 col-md-6">
                      <button
                        type="button"
                        onClick={(_) => this.setState({ modalFilters: true })}
                        className={styles.filtersBtn}
                      >
                        <img src={FilterIcon} alt="FilterIcon" />
                        فیلترها
                      </button>
                    </div>
                    <div className="col-3 d-none d-md-block col-md-3 text-left" style={{ textAlign: "left" }}>
                      مرتب سازی براساس:
                    </div>
                    <div className="col-7 col-md-3">
                      <select
                        name="sorts"
                        id="sorts"
                        value={this.state.sort}
                        onChange={(e) => {
                          this.changeSort(
                            this.state.filteredPhotographers,
                            e.target.value
                          );
                        }}
                        className={styles.formSelect}
                        aria-label="Default select example"
                      >
                        {this.state.sortItems.map((i) => {
                          return <option value={i.value}>{i.title}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                {displayPhotographers
                  .slice(0, this.state.nToShow)
                  .map((card) => {
                    const isSelected =
                      card.photographer_uid === this.state.photographerSelected;
                    const isMostPopular =
                      card.photographer_uid === this.state.mostPopularUid;
                    return (
                      <div
                        key={card.photographer_uid}
                        className={[
                          isSelected ? styles.preselectedCard : "",
                          isMostPopular ? styles.popularCard : "",
                          !isSelected && !isMostPopular ? styles.normalCard : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      >
                        {isMostPopular && (
                          <div className={styles.popularBadgeWrap}>
                            <span role="img" aria-label="پر انتخاب‌ترین">🔥</span>{" "}
                            پر انتخاب‌ترین این هفته
                          </div>
                        )}
                        <Card
                          data={card}
                          onClick={this.fillGallery}
                          onComments={this.fillComments}
                          isStudio={isStudio}
                          idComments={this.state.idComments}
                          photographerSelected={this.state.photographerSelected}
                          isRecommended={
                            card.photographer_uid ===
                            this.state.recommendedPhotographerUid
                          }
                          isMostPopular={isMostPopular}
                        />
                      </div>
                    );
                  })}
                {displayPhotographers.length >
                  this.state.nToShow && (
                  <div className={styles.loadMoreContainer}>
                    <div
                      className={styles.loadMore}
                      onClick={() => {
                        this.setState({ nToShow: this.state.nToShow + 3 });
                      }}
                    >
                      مشاهده متخصصین بیشتر
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    photographers: state.photographers,
    photographersEq: state.photographersEq,
    commentss: state.comments,
    project: state.project,
    change: state.change.change,
  };
};

export default connect(mapStateToProps, {
  getPhotographers,
  getComments,
  getData,
  changeData,
  unchangeData,
})(withRouter(Photographers));
